import { upperSnakeToCamelCase } from '@/utils/string';

export const getFormErrorMessage = (errors: Record<string, any>, registerName: string) => {
  const error = registerName.split('.').reduce<Record<string, any> | undefined>((acc, cur) => {
    const current = isNaN(+cur) ? cur : +cur;
    return acc?.[current];
  }, errors);

  return error?.message || '';
};

type CamelCase<S extends string> = S extends `${infer P1}_${infer P2}${infer P3}`
  ? `${Lowercase<P1>}${Uppercase<P2>}${CamelCase<P3>}`
  : Lowercase<S>;

export const getRegisterName = <T extends string[]>(keys: [...T]) => {
  return keys.reduce(
    (acc, key) => ({
      ...acc,
      [key]: upperSnakeToCamelCase(key)
    }),
    {} as const
  ) as { readonly [K in T[number]]: CamelCase<K> };
};
